import React from 'react';
import PropTypes from 'prop-types';
import ArticleListItem from './ArticleListItem';
import ListHeader from '../ListHeader';
import styles from './article-list.module.scss';

const ArticleList = ({articles}) => (
  <div>
    <ListHeader
      eyebrow="Popular articles"
      href="/article/77-welcome-to-teamgantt"
      linkText="Browse all articles"
      text="Start with the essentials"
    />
    <ul className={styles.ArticleList}>
      {articles.map(article => (
        <li key={article.id}>
          <ArticleListItem article={article} />
        </li>
      ))}
    </ul>
  </div>
);

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default ArticleList;



// WEBPACK FOOTER //
// ./src/components/articles/ArticleList.js